import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ofType } from '@ngrx/effects';
import { ActionsSubject, Store } from '@ngrx/store';
import { CartActions, MultiCartService } from '@spartacus/cart/base/core';
import { AuthRedirectService, UserIdService } from '@spartacus/core';
import { Observable, Subscription, take, tap } from 'rxjs';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';
@Component({
  selector: 'app-unit-list',
  templateUrl: './unit-list.component.html',
  styleUrls: ['./unit-list.component.scss'],
  standalone: false,
})
export class UnitListComponent implements OnDestroy {
  @Input() list: any;
  cartResolvedSubscription$: Subscription;

  get userCurrent(): string {
    let userCurrent: string;
    this.userIdService
      .getUserId()
      .pipe(take(1))
      .subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  constructor(
    private authRedirectService: AuthRedirectService,
    private storageService: StorageService,
    private cartExtendService: CartExtendService,
    protected store: Store<MultiCartService>,
    private userIdService: UserIdService,
    private multiCartService: MultiCartService,
    private componentService: ComponentService,
    private router: Router,
    private actionsSubject: ActionsSubject
  ) {}

  setB2Bunit(unitId: any) {
    this.storageService.setLocalStorageitem('shimanoSessionB2BUnit', unitId);
    let shimanoSessionB2BUnit = this.storageService.getLocalStorageItem('shimanoSessionB2BUnit');
    let setShimanoSessionB2BUnitSession = this.storageService.getSessionStorageItem('shimanoSessionB2BUnitSession');
    if (shimanoSessionB2BUnit) {
      if (setShimanoSessionB2BUnitSession !== null && shimanoSessionB2BUnit !== setShimanoSessionB2BUnitSession) {
        this.componentService.isB2BUnitFromPrevisSame$.next(false);
        this.redirectToNextPage(true);
      } else {
        this.componentService.isB2BUnitFromPrevisSame$.next(true);
        this.redirectToNextPage(false);
      }
      this.storageService.setSessionStorageItem('shimanoSessionB2BUnitSession', unitId);
      this.loadCurrentCartAsActiveCart()
        .pipe(take(1))
        .subscribe({
          next: (res) => {},
          error: (err) => {
            if (this.isCartNotFound(err)) {
              this.multiCartService.createCart({
                userId: this.userCurrent,
                extraData: {
                  active: true,
                },
              });
            }
          },
        });
    }
  }

  loadCurrentCartAsActiveCart(): Observable<any> {
    return this.cartExtendService.getCurrentCart().pipe(
      tap((cart) => {
        this.store.dispatch(
          new CartActions.LoadCart({
            userId: this.userCurrent,
            cartId: cart.code,
            extraData: {
              active: true,
            },
          })
        );
      })
    );
  }

  isCartNotFound(res: HttpErrorResponse): boolean {
    return res.error?.errors[0]?.type === 'CartError' && res.error?.errors[0]?.reason === 'notFound';
  }

  redirectToNextPage(toHomepage: boolean) {
    // Wait for CartActions.LoadCart on loadCurrentCartAsActiveCart() to finish before redirecting
    this.cartResolvedSubscription$ = this.actionsSubject
      .pipe(ofType(CartActions.LOAD_CARTS_SUCCESS, CartActions.LOAD_CART_SUCCESS, CartActions.LOAD_CART_FAIL), take(1))
      .subscribe(() => {
        if (toHomepage) {
          this.router.navigate(['/']);
        } else {
          this.authRedirectService.redirect();
        }
      });
  }

  ngOnDestroy(): void {
    this.cartResolvedSubscription$?.unsubscribe();
  }
}
